var _defs, _g, _g2, _g3, _g4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "46ea3b4811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 124 118.125 L 251 118.125 L 251 157 L 124 157 Z M 124 118.125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "87428d70ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 124 223 L 251 223 L 251 256.875 L 124 256.875 Z M 124 223 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "800f1a0ea1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.5 165 L 262.5 165 L 262.5 182 L 112.5 182 Z M 112.5 165 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25dbd21486"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.5 200 L 262.5 200 L 262.5 218 L 112.5 218 Z M 112.5 200 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46ea3b4811)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bd9b6b",
    d: "M 250.65625 156.785156 C 244.347656 130.339844 218.472656 118.109375 187.496094 118.109375 C 156.519531 118.109375 130.644531 130.339844 124.335938 156.785156 L 250.65625 156.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#87428d70ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bd9b6b",
    d: "M 124.335938 223.890625 C 130.644531 250.335938 156.519531 256.878906 187.496094 256.878906 C 218.472656 256.878906 244.347656 250.335938 250.65625 223.890625 L 124.335938 223.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#800f1a0ea1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20dad8",
    d: "M 254.242188 181.640625 L 120.75 181.640625 C 116.207031 181.640625 112.492188 177.921875 112.492188 173.382812 C 112.492188 168.839844 116.207031 165.125 120.75 165.125 L 254.242188 165.125 C 258.78125 165.125 262.5 168.839844 262.5 173.382812 C 262.5 177.921875 258.78125 181.640625 254.242188 181.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25dbd21486)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20dad8",
    d: "M 254.242188 217.449219 L 120.75 217.449219 C 116.207031 217.449219 112.492188 213.730469 112.492188 209.191406 C 112.492188 204.648438 116.207031 200.933594 120.75 200.933594 L 254.242188 200.933594 C 258.78125 200.933594 262.5 204.648438 262.5 209.191406 C 262.5 213.730469 258.78125 217.449219 254.242188 217.449219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bd9b6b",
    d: "M 251.820312 195.457031 L 123.171875 195.457031 C 120.667969 195.457031 118.621094 193.410156 118.621094 190.90625 C 118.621094 188.40625 120.667969 186.359375 123.171875 186.359375 L 251.820312 186.359375 C 254.320312 186.359375 256.371094 188.40625 256.371094 190.90625 C 256.371094 193.410156 254.320312 195.457031 251.820312 195.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger11);
export default __webpack_public_path__ + "static/media/burger11.a94afd76e4d93ec45458b6b03972b120.svg";
export { ForwardRef as ReactComponent };